import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit {
  field = new FormControl('');
  private lastValue = '';

  @Input() searchMode: 'debounced' | 'manual' = 'debounced';
  @Input() initialValue: string = '';
  @Input() theme: 'dark' | 'light' = 'dark';
  @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit() {
    if (this.initialValue) {
      this.field.setValue(this.initialValue);
      this.lastValue = this.initialValue;
    }

    if (this.searchMode === 'debounced') {
      this.field.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
        this.onSearch.emit(value ?? '');
      });
    } else {
      this.field.valueChanges.subscribe((value) => {
        const nextValue = value ?? '';
        const didClear = !!this.lastValue?.trim() && !nextValue.trim();
        this.lastValue = nextValue;
        if (didClear) this.onSearch.emit('');
      });
    }
  }

  triggerSearch() {
    this.onSearch.emit(this.field.value ?? '');
  }

  clear() {
    this.field.setValue('');
    this.lastValue = '';
    this.onSearch.emit('');
  }
}
